<template>
      <nav id="header" class="navbar is-fixed-top-desktop" role="navigation" aria-label="main navigation">        
        <div class="container">
          <div>
          <language-picker-vue></language-picker-vue>
        </div>
          <div class="navbar-brand">
            <router-link to="/" class="navbar-item is-logo">
              <img  src="../assets/images/logo_login.png" >
            </router-link>
            
          </div>
          <a role="button" @click="isOpen = !isOpen" :class="isOpen ? 'block is-active' : 'hidden'" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          <div class="navbar-menu"  :class="isOpen ? 'is-active' : 'hidden'">
            <div class="navbar-end">
              
              <a href="#about" class="navbar-item">
                {{$t('About')}}
              </a>
              <a href="#price" class="navbar-item">
                {{$t('Price')}}
              </a>
              <a href="#footer" class="navbar-item">
                {{$t('Download')}}
              </a>
              <a href="#footer" class="navbar-item">
                {{$t('Contact')}}
              </a>
              <a href="https://blog.horsetraq.app" target="_blank" class="navbar-item">
                {{$t('News')}}
              </a>
            </div>
          </div>
        </div>
      <a href='#banner' class="back-to-top">TOP</a>

      </nav>
</template>

<script>
import LanguagePickerVue from './LanguagePicker.vue'
export default {
  name: 'Header',
  data () {
      return {
          isOpen: false,
      }
  },
  components:{
    LanguagePickerVue
  },
}
</script>

